var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3014_11839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 22.0001C2.46667 22.0001 2.30417 21.9376 2.18334 21.8167C1.9375 21.5709 1.9375 21.1751 2.18334 20.9334L20.9333 2.1834C21.1792 1.93757 21.575 1.93757 21.8167 2.1834C22.0625 2.42923 22.0625 2.82507 21.8167 3.06673L3.06667 21.8167C2.94584 21.9376 2.78334 22.0001 2.625 22.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 22.0001C21.2167 22.0001 21.0542 21.9376 20.9333 21.8167L2.18334 3.06673C1.9375 2.82507 1.9375 2.42507 2.18334 2.1834C2.42917 1.93757 2.82084 1.93757 3.06667 2.1834L21.8167 20.9334C22.0625 21.1792 22.0625 21.5751 21.8167 21.8167C21.6958 21.9376 21.5333 22.0001 21.375 22.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3014_11839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.f75b8f1b0186fe3a2f3dc67eeb40995e.svg";
export { ForwardRef as ReactComponent };